import { nanoid } from "nanoid";
import { joinLines, mapTabs } from "../../helpers/exportHelpers";
import { IExportArtifact } from "../ExportArtifacts/IExportArtifact";
import { IModelInfo } from "../ModelInfos/IModelInfo";

export function generateCsharpClass(models: IModelInfo[]): IExportArtifact[] {
    const artifacts: IExportArtifact[] = [];
    const tab = "    ";
    const line = "\r\n";

    for (const model of models) {
        const properties = model.members.map(x => `\tpublic ${x.type.name} ${x.name} { get; set; }`);

        const classContent = mapTabs(tab, [
            `public class ${model.name}`,
            `{`,
            ...properties,
            `}`
        ], 1);

        const usings = model.imports.map(x => `using ${x};`)

        const fileContent = joinLines(line, [
            ...usings,
            '',
            `namespace ${model.namespace}`,
            `{`,
                ...classContent,
            `}`,
            ''
        ]);

        const artifact: IExportArtifact = {
            id: nanoid(),
            exportId: nanoid(),
            created: new Date(),
            fileName: `${model.name}.cs`,
            content: fileContent
        };
        artifacts.push(artifact);
    }

    return artifacts;
}
